function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { SearchPageReadyToLoadSearch, SearchPageSwitchRequestedEvent, SearchType } from '@studyportals/search-page-interface';
export class OrganisationSearchLoader {
    async initialize() {
        if (this.isUniversitySearchUrl() || this.isUniversitySearchStandalone()) {
            await this.load();
            return;
        }
        window.EventAggregationService?.subscribeTo(SearchPageReadyToLoadSearch.EventType, this, true);
    }
    async notify(event) {
        if (event.searchType === SearchType.ORGANISATION) {
            await this.load(event);
        }
    }
    async load(event) {
        if (this.loaded) return;
        await import('./main');
        this.loaded = true;
        if (event?.onSwitchSearchType) {
            window.EventAggregationService?.publishTo(SearchPageSwitchRequestedEvent.EventType, new SearchPageSwitchRequestedEvent(SearchType.ORGANISATION));
        }
    }
    isUniversitySearchUrl() {
        return window.location.href.includes('search/universities');
    }
    isUniversitySearchStandalone() {
        const allowed = 'organisations-search.prtl.co';
        try {
            const url = new URL(window.location.href);
            return url.host === allowed;
        } catch  {
            return false;
        }
    }
    constructor(){
        _define_property(this, "loaded", false);
    }
}
const loader = new OrganisationSearchLoader();
await loader.initialize();
